<template>
  <!--
      作者 tanzhihui
      时间：2020-09-15
      描述：会员-好友圈管理-添加好友圈
  -->
  <el-dialog title="添加好友圈" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false" width="600px">
    <el-form size="small" :model="form" ref="form">
      <el-form-item label="好友名称" :label-width="formLabelWidth" prop="name" :rules="[{required: true,message: '请输入名称'}]">
        <el-input v-model="form.name" placeholder="请输入名称"></el-input>
      </el-form-item>
    <el-form-item label="好友生日"  prop="birthday_time" :label-width="formLabelWidth" :rules="[{required:true,message:'请选择日期'}]" >
        <el-col>
            <el-date-picker type="date" placeholder="选择日期" v-model="form.birthday_time" style="width: 100%;"></el-date-picker>
        </el-col>
  </el-form-item>
  <el-form-item label="备注" :label-width="formLabelWidth" prop="remark">
        <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addFriends()" :disabled="submit_loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import FriendsApi from '@/api/friends.js';
  export default {
    data() {
      return {
        form: {
          /*姓名*/
          name: '',
          /*生日*/
          birthday_time: '',
          // 备注
          remark:'',
        },
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,
        /*是否正在提交*/
        submit_loading: false,
      };
    },
    props: ['open_add'],
    created() {
      this.dialogVisible = this.open_add;
    },
    methods: {

      /*添加等级*/
      addFriends() {
        let self = this;
        let params = this.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            params.birthday_time = this.formateDate(params.birthday_time);
            self.submit_loading = true;
            FriendsApi.addfriends(params, true).then(data => {
                self.submit_loading = false;
                self.$message({
                  message: data.msg,
                  type: 'success'
                });
                self.dialogFormVisible(true);
              })
              .catch(error => {
                self.submit_loading = false;
              });
          }
        });
      },
      //转换时间格式
formateDate(datetime) {
    function addDateZero(num) {
        return (num < 10 ? "0" + num : num);
    }
    let d = new Date(datetime);
    let formatdatetime = d.getFullYear() + '-' + addDateZero(d.getMonth() + 1) + '-' + addDateZero(d.getDate()) + ' ' + addDateZero(d.getHours()) + ':' + addDateZero(d.getMinutes()) + ':' + addDateZero(d.getSeconds());
    return formatdatetime;
},
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      }

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/friends/Add.vue